import { Component, TemplateRef } from '@angular/core';
import { IrisAgGridFloatingFilterBaseComponent } from '@iris/common/modules/grid/ag-grid/components/ag-grid-floating-filter-base.component';
import { IFloatingFilter } from 'ag-grid-community';
import { IrisFloatingFilterForTemplateParam } from '@iris/common/modules/grid/ag-grid/models/floating-filter-for-template-params';

@Component({
  templateUrl: './ag-grid-filter-template-renderer.component.html',
  standalone: false,
})
export class AgGridFilterTemplateRendererComponent extends IrisAgGridFloatingFilterBaseComponent<IrisFloatingFilterForTemplateParam> implements IFloatingFilter {
  public templateRef: TemplateRef<any>;

  agInit(params: IrisFloatingFilterForTemplateParam) {
    super.agInit(params);

    this.templateRef = this.params.customTemplate;
  }
}
